import { nanoid } from 'nanoid';

/** 21-char URL-safe id, generated client-side (works offline, collision-free in practice). */
export const newId = (): string => nanoid();

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isUuid = (s: string): boolean => UUID.test(s);

/**
 * Asset ids are the `assets.id` uuids of the server (spec §F.1), chosen by the client so an image appears before
 * its upload. Built from getRandomValues, which unlike randomUUID also works outside secure contexts (LAN over HTTP).
 */
export function newAssetId(): string {
  const b = crypto.getRandomValues(new Uint8Array(16));
  b[6] = (b[6]! & 0x0f) | 0x40;
  b[8] = (b[8]! & 0x3f) | 0x80;
  const hex = [...b].map((x) => x.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
